import React, { useEffect, useState, useRef } from "react";
import { cn } from "../lib/helpers";

import * as styles from "../styles/components/video.module.css";

interface VideoAsset {
  asset?: {
    url?: string;
    originalFilename?: string;
  }
}

interface VideoProps {
  webm?: VideoAsset;
  mp4?: VideoAsset;
  delay?: boolean;
}

const Video: React.FC<VideoProps> = ({ webm, mp4, delay }) => {
  const [loading, setLoading] = useState(true);
  const ref = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const videoElement = ref.current;
    if (!videoElement) return;

    const timer = setTimeout(() => {
      setLoading(false);
      videoElement.play();
    }, delay ? 1000 : 0);

    videoElement.load(); // Force reload of video sources to fix React caching issue

    return () => {
      clearTimeout(timer);
    };
  }, [delay]);

  if (!webm?.asset || !mp4?.asset) {
    return null;
  }

  const webmUrl = `${webm.asset.url}/${webm.asset.originalFilename}/`;
  const mp4Url = `${mp4.asset.url}/${mp4.asset.originalFilename}/`;

  return (
    <video
      loop
      muted
      playsInline
      ref={ref}
      className={cn(styles.root, !loading && styles.show)}
    >
      <source src={webmUrl} type="video/webm" />
      <source src={mp4Url} type="video/mp4" />
    </video>
  );
};

export default Video;
